import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDStack,
  FDPrimaryActionButton,
  FDBodyText,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';

export default function Layout({
  onConfirm,
  loading,
}) {
  const { resource } = useMetaLayoutContext();

  const hasExistingActionItemsToDelete = resource.metaField('existingActionItemsToDelete').options().length() > 0;

  return (
    <React.Fragment>
      <FDStack direction="column" alignItems="flex-end" {...dataAttrs('send-proposal-confirmation-dialog')}>

        {hasExistingActionItemsToDelete ? (
          <React.Fragment>
            <FDBodyText value="Additionally, please select any manually created actions that should be deleted in context of this new scenario." />
            <br />
            <FDBox minWidth="100%">
              <MetaField resource={resource} attr="existingActionItemsToDelete" fullWidth />
            </FDBox>
          </React.Fragment>
        ) : (
          <FDBodyText value="This household does not have any pre-existing manually created actions that require your review for deletion." />
        )}

        <br />
        <FDPrimaryActionButton
          label="Confirm & Send"
          onClick={onConfirm}
          loading={loading}
        />
      </FDStack>
    </React.Fragment>
  );
}

Layout.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
